import React, { useState, useMemo } from 'react';
import styles from './approveStatus.module.scss';
import { getIn18Text, IApprovalRecordStatus } from 'api';
import ApprovalActionModal from '@web-approval-flow/components/ApprovalActionModal';
import { APPROVAL_CONFIG } from '@web-approval-flow/components/ApprovalStateTag';
const ApproveStatus = props => {
    var _a;
    const { recordFlow, fetchApprovalFlow, checkApproval } = props;
    const [actionModalInfo, setActionModalInfo] = useState({ visible: false, actionType: 'toRecall', bizName: '', recordId: '' });
    const recordStatus = useMemo(() => recordFlow === null || recordFlow === void 0 ? void 0 : recordFlow.recordStatus, [recordFlow]);
    const showWithdraw = useMemo(() => {
        if (recordStatus && [IApprovalRecordStatus.processing].includes(recordStatus))
            return true;
        return false;
    }, [recordStatus]);
    const approvalData = useMemo(() => {
        const approvalData = APPROVAL_CONFIG[recordStatus];
        return approvalData || {};
    }, [recordStatus]);
    const curApprover = useMemo(() => {
        const { flowList } = recordFlow;
        if (!flowList || flowList.length === 0)
            return '';
        const latestFlow = flowList[flowList.length - 1];
        const { accountInfoList } = latestFlow;
        if (!accountInfoList || accountInfoList.length === 0)
            return '';
        return accountInfoList.map(item => (item === null || item === void 0 ? void 0 : item.accName) || '').join(',');
    }, [recordFlow]);
    const toCheckApprove = () => {
        checkApproval && checkApproval();
    };
    const withdrawApprove = async () => {
        setActionModalInfo({
            visible: true,
            actionType: 'toRecall',
            bizName: recordFlow.bizName || '',
            recordId: recordFlow.recordId,
        });
    };
    const onActionModalClose = (closeType) => {
        setActionModalInfo({
            visible: false,
            actionType: 'toRecall',
            bizName: '',
            recordId: '',
        });
        if (closeType === 'success') {
            fetchApprovalFlow && fetchApprovalFlow();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.approveStatus, style: { background: ((_a = approvalData === null || approvalData === void 0 ? void 0 : approvalData.style) === null || _a === void 0 ? void 0 : _a.backgroundColor) || '' } },
            React.createElement("div", { className: styles.approveCont },
                React.createElement("span", { className: styles.approveIcon }, approvalData.icon),
                React.createElement("span", { className: styles.approveState }, approvalData.label),
                "\uFF0C",
                React.createElement("span", { className: styles.approver },
                    getIn18Text('Approver'),
                    "\uFF1A",
                    curApprover)),
            React.createElement("div", { className: styles.buts },
                React.createElement("span", { className: styles.checkApprove, onClick: () => toCheckApprove() }, getIn18Text('CHAKANSHENP')),
                showWithdraw && (React.createElement("span", { className: styles.withdrawApprove, onClick: () => withdrawApprove() }, getIn18Text('CHEHUISHENPI'))))),
        React.createElement(ApprovalActionModal, { info: actionModalInfo, onClose: onActionModalClose })));
};
export default ApproveStatus;
